import AdminProductListItem from './AdminProductListItem';

export default AdminProductListItem;
